import styled from "styled-components";

export const Nav = styled.nav`
  height: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  top: 0;
  padding: 0 7%;
  z-index: 999;
`;

export const NavBar = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 1;
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;

  img {
    width: 15rem;
    margin-right: 48px;
    @media screen and (max-width: 700px) {
      margin: 0;
    }
  }
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 700px) {
    margin-left: auto;
    cursor: pointer;
    display: flex;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  list-style: none;
  @media screen and (max-width: 700px) {
    position: absolute;
    display: flex;
    top: 8rem;
    right: 10px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background: rgba(255, 255, 255, 0.99);
    overflow: hidden;
    box-shadow: 0px 10px 10px #00000029;
    flex-direction: column;
    width: 150px;
    max-width: 35rem;
    max-height: ${(props) => (props.status ? "300px" : 0)};
    transition: max-height 0.3s ease-in;
  }
`;
